 enum Airline {
    Lufthansa,
}

export default Airline;
